import { SearchHealthResourcesResponse } from '@/app/(main)/_components/search-modal/search-modal.types';
import { publicSearchClient } from '@/datasources/public-search.datasource';

export async function searchHealthResourcesByType(
  searchTerm: string,
  type: string,
  page = 1,
  limit = 10,
): Promise<SearchHealthResourcesResponse> {
  const { data } = await publicSearchClient.get<SearchHealthResourcesResponse>(
    '/health-resources/',
    {
      search: searchTerm,
      page,
      limit,
      searchType: type,
    },
  );

  return data;
}
